import { CheckoutStep } from "../store/CheckoutV2Store.js";
var CheckoutMatomoUiStep = /*#__PURE__*/ function(CheckoutMatomoUiStep) {
    CheckoutMatomoUiStep["PersonalInformation"] = "personal-information";
    CheckoutMatomoUiStep["Payment"] = "payment";
    CheckoutMatomoUiStep["Confirmation"] = "confirmation";
    return CheckoutMatomoUiStep;
}(CheckoutMatomoUiStep || {});
/**
 * Collapse the fine-grained checkout v2 `CheckoutStep` enum + `view` flag
 * into the three Matomo funnel buckets shared by every v2 tracking surface
 * (page-views + ecommerce events). Returns `undefined` while the checkout
 * is still bootstrapping so callers can short-circuit.
 */ function resolveReadyUiStep(step, view, loading) {
    if (loading) {
        return undefined;
    }
    // Confirmation view — the buyer landed on the success screen.
    if (view === "success" || step >= CheckoutStep.PaymentCompleted) {
        return "confirmation";
    }
    // Payment frame visible — anything between identification submitted and payment completed.
    if (step >= CheckoutStep.IdentificationSubmitted) {
        return "payment";
    }
    // Pre-submit — buyer is still filling in personal information.
    if (step >= CheckoutStep.VendorReady) {
        return "personal-information";
    }
    return undefined;
}
export { CheckoutMatomoUiStep, resolveReadyUiStep };
